import React from 'react';

export type HeaderContextData = {
    container: HTMLElement | null;
    transparent: boolean;
    setTransparent(flag: boolean): void;
    isInProject: boolean;
    // When true, the global Header returns null so callers can render a fully chromeless page
    // (e.g., showroom widget embedded as an iframe).
    hidden?: boolean;
    setHidden(flag: boolean): void;
    // setContainer(container: HTMLElement): void;
};

const HeaderContext = React.createContext<HeaderContextData>({
    container: null,
    transparent: false,
    setTransparent: () => {},
    isInProject: false,
    hidden: false,
    setHidden: () => {},
    // setContainer: () => {},
});

export default HeaderContext;

